(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-cart-checkout')) {
    class JoaCartCheckout extends HTMLElement {
      #abort;
      #cart;
      #media;
      #mutations;
      #resize;
      #frame = 0;

      connectedCallback() {
        if (!this.closest('.cart-page__summary')) return;
        this.#cart = this.closest('cart-items-component');
        if (!this.#cart) return;

        this.#abort = new AbortController();
        this.#media = window.matchMedia('(max-width: 749px)');
        const options = { passive: true, signal: this.#abort.signal };
        document.addEventListener('scroll', this.#schedule, { ...options, capture: true });
        window.addEventListener('resize', this.#schedule, options);
        window.addEventListener('pageshow', this.#schedule, options);
        document.addEventListener('focusin', this.#schedule, options);
        document.addEventListener('focusout', this.#schedule, options);
        this.#media.addEventListener('change', this.#refresh, options);
        window.visualViewport?.addEventListener('resize', this.#schedule, options);

        this.#resize = new ResizeObserver(this.#refresh);
        this.#resize.observe(this.#cart);
        this.#mutations = new MutationObserver(this.#refresh);
        this.#mutations.observe(this.#cart, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'hidden']
        });
        this.#schedule();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#resize?.disconnect();
        this.#mutations?.disconnect();
        cancelAnimationFrame(this.#frame);
        this.#frame = 0;
        const floating = this.#cart?.querySelector('.joa-cart-sticky-checkout');
        if (floating) {
          floating.hidden = true;
          floating.removeAttribute('data-visible');
        }
      }

      #schedule = () => {
        if (!this.#frame) this.#frame = requestAnimationFrame(this.#update);
      };

      #refresh = () => {
        this.#schedule();
      };

      #update = () => {
        this.#frame = 0;
        if (!this.isConnected) return;

        const floating = this.#cart.querySelector('.joa-cart-sticky-checkout');
        if (!floating) return;
        const original = this.querySelector('.cart__checkout-button');
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const rect = original?.getBoundingClientRect();
        const available = original && !original.disabled && original.getAttribute('aria-disabled') !== 'true';
        const show = this.#media.matches && available && !editing && rect.width > 0 && rect.height > 0 && rect.bottom <= 0;

        if (!show && !floating.hidden && floating.contains(document.activeElement) && rect?.bottom > 0 && rect.top < window.innerHeight) {
          original.focus({ preventScroll: true });
        }
        if (floating.hidden === Boolean(show)) floating.hidden = !show;
        floating.toggleAttribute('data-visible', Boolean(show));
      };
    }

    customElements.define('joa-cart-checkout', JoaCartCheckout);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-3d-preview-message"] && !Shopify.designMode) return;
  try {
    function initJoaDemoVideos(scope = document) {
  scope.querySelectorAll('[data-joa-demo-video]').forEach(video => {
    if (video.dataset.bound) return;
    video.dataset.bound = 'true';
    video.controls = false;
    video.tabIndex = 0;
    video.setAttribute('role', 'button');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let manuallyPaused = false;
    const sync = () => { video.setAttribute('aria-label', video.paused ? video.dataset.playLabel : video.dataset.pauseLabel); };
    sync();
    const play = () => { video.play().catch(sync); };
    const toggle = () => {
      manuallyPaused = !video.paused;
      if (video.paused) play(); else video.pause();
    };
    video.addEventListener('click', toggle);
    video.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (!event.repeat) toggle();
    });
    video.addEventListener('play', sync); video.addEventListener('pause', sync);
    reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
    new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting && !reduced.matches && !manuallyPaused && !document.hidden) play();
      else video.pause();
    }), { threshold: .25 }).observe(video);
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  });
}
initJoaDemoVideos();
document.addEventListener('shopify:section:load', event => initJoaDemoVideos(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-bracelet-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-bracelet-details')) {
    customElements.define('joa-bracelet-details', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        import('@shopify/events').then(({ StandardEvents }) => {
          if (signal.aborted) return;
          this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
            if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
            event.promise.then(({ detail }) => {
              if (signal.aborted || !detail?.html || String(detail.productId) !== this.dataset.productId) return;
              const next = detail.html.querySelector('joa-bracelet-details');
              if (!next || next.dataset.productId !== this.dataset.productId) return;
              const openKey = this.querySelector('details[open]')?.dataset.detail;
              this.replaceChildren(...Array.from(next.childNodes, node => node.cloneNode(true)));
              this.dataset.variantId = next.dataset.variantId;
              this.querySelectorAll('details').forEach(item => { item.open = item.dataset.detail === openKey; });
            }).catch(error => {
              if (error?.name !== 'AbortError') console.warn('Bracelet details could not be updated.', error);
            });
          }, { signal });
        }).catch(error => console.warn('Bracelet details could not be initialized.', error));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-catalogue-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-catalogue-details')) {
    customElements.define('joa-catalogue-details', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        import('@shopify/events').then(({ StandardEvents }) => {
          if (signal.aborted) return;
          this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
            if (event.target.closest('product-card')) return;
            const request = this.request = event.promise;
            request.then(({ detail }) => {
              if (signal.aborted || request !== this.request || String(detail?.productId) !== this.dataset.productId) return;
              const next = detail.html?.querySelector('joa-catalogue-details');
              const specs = this.querySelector('[data-joa-catalogue-specs]');
              const nextSpecs = next?.querySelector('[data-joa-catalogue-specs]');
              if (specs && nextSpecs) specs.replaceWith(nextSpecs.cloneNode(true));
              const assurances = this.querySelector('[data-joa-assurances]');
              const nextAssurances = next?.querySelector('[data-joa-assurances]');
              if (assurances && nextAssurances) assurances.replaceWith(nextAssurances.cloneNode(true));
              if (next) this.dataset.variantId = next.dataset.variantId;
            }).catch(() => {});
          }, { signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-drawer-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', event => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.open || !current.dataset.joaMenuGroup) return;
    current.closest('.joa-menu-tree')?.querySelectorAll('[data-joa-menu-group][open]').forEach(other => {
      if (other !== current && other.dataset.joaMenuGroup === current.dataset.joaMenuGroup) other.open = false;
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-earring-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-earring-details')) {
    customElements.define('joa-earring-details', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        import('@shopify/events').then(({ StandardEvents }) => {
          if (signal.aborted) return;
          this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
            if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
            event.promise.then(({ detail }) => {
              if (signal.aborted || !detail?.html || String(detail.productId) !== this.dataset.productId) return;
              const next = detail.html.querySelector('joa-earring-details');
              if (!next || next.dataset.productId !== this.dataset.productId) return;
              const openKey = this.querySelector('details[open]')?.dataset.detail;
              this.replaceChildren(...Array.from(next.childNodes, node => node.cloneNode(true)));
              this.dataset.variantId = next.dataset.variantId;
              this.querySelectorAll('details').forEach(item => { item.open = item.dataset.detail === openKey; });
            }).catch(error => {
              if (error?.name !== 'AbortError') console.warn('Earring details could not be updated.', error);
            });
          }, { signal });
        }).catch(error => console.warn('Earring details could not be initialized.', error));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-engraving-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-engraving')) {
  class JoaEngraving extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form') || this.closest('.mw-tingle');
      this.cartEdit = this.dataset.cartEdit === 'true';
      this.dialog = this.querySelector('[data-engraving-dialog]');
      this.input = this.querySelector('[data-engraving-input]');
      this.property = this.querySelector('[data-engraving-property]');
      this.opener = this.querySelector('[data-engraving-open]');
      this.copy = JSON.parse(this.querySelector('[data-personalization-copy]').textContent);
      this.storageKey = 'joa-engraving:' + this.dataset.productId;
      this.designKey = 'joa-personalization:' + this.dataset.productId;
      this.saved = ''; this.font = 'script'; this.position = 'sides';
      try {
        this.saved = this.clean(sessionStorage.getItem(this.storageKey) || '');
        const stored = JSON.parse(sessionStorage.getItem(this.designKey) || '{}');
        if (['script', 'classic'].includes(stored.font)) this.font = stored.font;
        if (['before', 'after', 'sides'].includes(stored.position)) this.position = stored.position;
      } catch {}
      if (this.cartEdit) {
        let properties = {};
        try { properties = JSON.parse(this.dataset.initialProperties || '{}'); } catch {}
        this.saved = this.clean(properties.Engraving || '');
        this.font = properties['Engraving font'] === this.copy.classic || properties['Engraving font'] === 'Classic' ? 'classic' : 'script';
        this.position = ['before', 'after', 'sides'].find(key => properties['Stone placement'] === this.copy[key]) || (/before/i.test(properties['Stone placement'] || '') ? 'before' : /after/i.test(properties['Stone placement'] || '') ? 'after' : 'sides');
      }
      this.draftFont = this.font; this.draftPosition = this.position;
      const unique = 'personalization-' + crypto.randomUUID();
      this.dialog.id = unique; this.opener.setAttribute('aria-controls', unique);
      this.querySelectorAll('linearGradient').forEach(gradient => {
        const previous = gradient.id;
        gradient.id = previous + '-' + unique;
        this.querySelectorAll('[fill="url(#' + previous + ')"]').forEach(path => path.setAttribute('fill', 'url(#' + gradient.id + ')'));
      });
      this.extraProperties = {};
      for (const name of ['Engraving font', 'Stone placement', '_joa_personalization_layout']) {
        const input = document.createElement('input'); input.type = 'hidden';
        input.name = 'properties[' + name + ']'; input.dataset.personalizationProperty = ''; input.disabled = true;
        this.append(input); this.extraProperties[name] = input;
      }
      this.opener.addEventListener('click', () => {
        this.input.value = this.saved; this.draftFont = this.font; this.draftPosition = this.position;
        this.stones()?.beginDraft(); this.updateMetal(); this.updatePreview();
        this.dialog.showModal(); requestAnimationFrame(() => this.updatePreview());
        document.fonts?.load('40px "Petit Formal Script"').then(() => {
          if (this.isConnected && this.dialog.open) this.updatePreview();
        }).catch(() => {});
        this.dialog.focus({ preventScroll: true });
      });
      this.querySelector('[data-engraving-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const b = this.dialog.getBoundingClientRect();
        if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.opener.focus({ preventScroll: true }));
      this.dialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); });
      this.dialog.addEventListener('scroll', () => {
        if (this.previewFrame) return;
        this.previewFrame = requestAnimationFrame(() => {
          this.previewFrame = 0;
          if (this.dialog.open) this.updatePreview();
        });
      }, { passive: true });
      this.input.addEventListener('input', () => this.updatePreview());
      this.input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.commit(this.input.value); } });
      this.querySelector('[data-engraving-save]').addEventListener('click', () => this.commit(this.input.value));
      this.querySelector('[data-engraving-remove]').addEventListener('click', () => {
        this.input.value = ''; this.draftFont = 'script'; this.draftPosition = 'sides';
        const stones = this.stones(); if (stones) { stones.draft = []; stones.render(); }
        this.commit('');
      });
      this.querySelectorAll('[data-personalization-font]').forEach(button => button.addEventListener('click', () => { this.draftFont = button.dataset.personalizationFont; this.updatePreview(); }));
      this.querySelectorAll('[data-personalization-position]').forEach(button => button.addEventListener('click', () => { this.draftPosition = button.dataset.personalizationPosition; this.updatePreview(); }));
      this.form?.addEventListener('formdata', event => {
        event.formData.delete('properties[Engraving]'); if (this.saved) event.formData.set('properties[Engraving]', this.saved);
        for (const [name, input] of Object.entries(this.extraProperties)) {
          event.formData.delete('properties[' + name + ']');
          if (!input.disabled && input.value) event.formData.set('properties[' + name + ']', input.value);
        }
      });
      this.form?.addEventListener('change', () => this.updateMetal());
      this.form?.addEventListener('click', event => { if (!this.contains(event.target)) requestAnimationFrame(() => this.updateMetal()); });
      this.relocate = () => {
        if (!this.isConnected || !this.form) return;
        const size = this.form.querySelector('.mw-apo-container [data-joa-option-name="Ring Size"]');
        if (size && size.nextElementSibling !== this) size.after(this);
        this.updateMetal();
      };
      this.observer = new MutationObserver(() => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.relocate); });
      this.observer.observe(this.form || this, { childList: true, subtree: true });
      this.syncSaved(); this.relocate();
      customElements.whenDefined('joa-birthstones').then(() => { if (this.isConnected) this.syncSaved(); });
    }
    disconnectedCallback() { queueMicrotask(() => { if (!this.isConnected) { this.observer?.disconnect(); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.previewFrame); } }); }
    stones() { return this.querySelector('joa-birthstones[data-integrated="true"]'); }
    characters(text) { const value = String(text).replace(/[\u0000-\u001f\u007f]/g, ''); return typeof Intl.Segmenter === 'function' ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), item => item.segment) : Array.from(value); }
    clean(text) { return this.characters(text).slice(0, 16).join(''); }
    summary() {
      const count = this.stones()?.saved?.length || 0;
      return [this.saved ? '“' + this.saved + '”' : '', count ? count === 1 ? this.copy.one_stone : this.copy.many_stones.replace('[count]', count) : ''].filter(Boolean).join(' · ') || this.copy.hint;
    }
    updateMetal() {
      const scope = this.form?.closest('.product-details, .joa-quick-ring, .shopify-section') || this.form || this.parentElement;
      const choice = scope.querySelector('.joa-option--metal [role="radio"][aria-checked="true"]');
      const option = scope.querySelector('.joa-option--metal');
      const checked = option?.querySelector('input:checked');
      const select = option?.querySelector('select') || scope.querySelector('select[name*="Material"],select[name*="Metal"]');
      const native = scope.querySelector('input[name*="Material"]:checked,input[name*="Metal"]:checked');
      let metal = choice?.getAttribute('aria-label') || (checked && (checked.getAttribute('aria-label') || checked.labels?.[0]?.textContent)) || select?.selectedOptions?.[0]?.textContent || native?.value || this.dataset.defaultMetal || '';
      metal = metal.replace(/\s+/g, ' ').trim(); if (/default title/i.test(metal)) metal = '';
      const tone = /rose/i.test(metal) ? 'rose' : /platinum/i.test(metal) ? 'platinum' : /white/i.test(metal) && !/2.?tone|two.?tone/i.test(metal) ? 'white' : 'yellow';
      const preview = this.querySelector('[data-engraving-preview]'); if (preview.dataset.metal !== tone) preview.dataset.metal = tone;
      const label = this.querySelector('[data-engraving-metal]'); if (label.textContent !== metal) label.textContent = metal;
    }
    updatePreview() {
      const value = this.clean(this.input.value); if (this.input.value !== value) this.input.value = value;
      const stones = this.stones(), ids = stones?.draft || [];
      if (ids.length === 1 && this.draftPosition === 'sides') this.draftPosition = 'after';
      this.querySelector('[data-personalization-placement]').hidden = !value.trim() || !ids.length;
      this.querySelectorAll('[data-personalization-font]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.personalizationFont === this.draftFont)));
      this.querySelectorAll('[data-personalization-position]').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.personalizationPosition === this.draftPosition));
        b.disabled = b.dataset.personalizationPosition === 'sides' && ids.length < 2;
      });
      const text = this.querySelector('[data-engraving-text]'); text.textContent = value || (ids.length ? '' : this.copy.empty_preview);
      text.dataset.font = this.draftFont; text.removeAttribute('textLength'); text.removeAttribute('lengthAdjust');
      const maxText = ids.length ? 310 : 470;
      let width = text.getComputedTextLength();
      if (width > maxText) { text.setAttribute('textLength', String(maxText)); text.setAttribute('lengthAdjust', 'spacingAndGlyphs'); width = maxText; }
      if (!value && ids.length) width = 0;
      const leftCount = !value ? ids.length : this.draftPosition === 'before' ? ids.length : this.draftPosition === 'sides' ? Math.ceil(ids.length / 2) : 0;
      const rightCount = ids.length - leftCount;
      const step = Math.min(34, (520 - width - (value && ids.length ? 32 : 0)) / Math.max(1, ids.length));
      const gapLeft = value && leftCount ? 16 : 0, gapRight = value && rightCount ? 16 : 0;
      const total = width + ids.length * step + gapLeft + gapRight;
      const start = 320 - total / 2, textX = start + leftCount * step + gapLeft + width / 2;
      text.setAttribute('x', String(textX));
      const host = this.querySelector('[data-personalization-gems]'); host.replaceChildren();
      ids.forEach((key, i) => {
        const x = i < leftCount ? start + (i + .5) * step : start + leftCount * step + gapLeft + width + gapRight + (i - leftCount + .5) * step;
        host.append(stones.previewGem(key, x, 156, Math.min(12, step / 2.6)));
      });
      this.querySelector('[data-engraving-count]').textContent = this.characters(value).length + '/16';
      this.querySelector('[data-engraving-save]').disabled = false;
      this.querySelector('[data-engraving-remove]').hidden = !(this.saved || this.stones()?.saved?.length || value || ids.length);
    }
    syncSaved() {
      if (!this.copy) return;
      const stones = this.stones(), ids = stones?.saved || [], any = Boolean(this.saved || ids.length);
      this.property.value = this.saved; this.property.disabled = !this.saved; this.dataset.saved = String(any);
      const label = this.querySelector('[data-engraving-label]'); if (label.textContent !== this.copy.title) label.textContent = this.copy.title;
      const summary = this.querySelector('[data-personalization-summary]'); if (summary.textContent !== this.summary()) summary.textContent = this.summary();
      this.querySelector('[data-engraving-action]').textContent = any ? this.copy.edit : '+';
      const names = ids.map(k => stones.copy[k]);
      const text = this.saved ? '“' + this.saved + '”' : '';
      const split = this.position === 'before' ? ids.length : this.position === 'sides' ? Math.ceil(ids.length / 2) : 0;
      const layout = text ? [...names.slice(0, split), text, ...names.slice(split)].join(' → ') : names.join(' → ');
      const properties = { 'Engraving font': this.saved ? this.copy[this.font] : '', 'Stone placement': this.saved && ids.length ? this.copy[this.position] : '', '_joa_personalization_layout': ids.length ? layout : '' };
      for (const [name, value] of Object.entries(properties)) { const input = this.extraProperties[name]; if (!input) continue; input.value = value; input.disabled = !value; }
      window.JoaOptionDesign?.styleEngraving?.(this.form);
    }
    commit(value) {
      this.saved = this.clean(value).trim(); this.font = this.draftFont; this.position = this.draftPosition;
      this.stones()?.commit(false); this.syncSaved();
      if (!this.cartEdit) try { if (this.saved) sessionStorage.setItem(this.storageKey, this.saved); else sessionStorage.removeItem(this.storageKey); sessionStorage.setItem(this.designKey, JSON.stringify({font:this.font, position:this.position})); } catch {}
      document.dispatchEvent(new CustomEvent('joa:engraving-change', { detail: { form:this.form, value:this.saved } }));
      this.dialog.close();
    }
  }
  customElements.define('joa-engraving', JoaEngraving);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-inquiry-photos"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'joa-inquiry-photos-v1';
  function setup(root = document) {
    if (root.querySelector('.joa-inquiry-success')) {
      try { sessionStorage.removeItem(key); } catch {}
    }
    root.querySelectorAll('[data-joa-photo-upload]').forEach(host => {
      if (host.dataset.bound) return;
      host.dataset.bound = 'true';
      const form = host.closest('form'), frame = host.querySelector('[data-photo-frame]');
      const links = host.querySelector('[data-photo-links]'), status = host.querySelector('[data-photo-status]');
      const recovery = host.querySelector('[data-photo-recovery]');
      if (!form || !frame || !links) return;
      let origin, session, ready = false, pending = true, failed = false, skipped = false, timer;
      const show = message => { status.textContent = message; };
      try {
        const url = new URL(host.dataset.uploadUrl);
        if (url.protocol !== 'https:') throw new Error();
        origin = url.origin;
      } catch {
        show(host.dataset.unavailable); recovery.hidden = false;
      }
      try { session = sessionStorage.getItem(key); } catch {}
      if (!/^[a-f0-9-]{36}$/.test(session || '')) session = crypto.randomUUID();
      try { sessionStorage.setItem(key, session); } catch {}
      const init = () => frame.contentWindow?.postMessage({source: 'joa-form-v1', type: 'init', session}, origin);
      const launch = () => {
        if (!origin) return;
        ready = false; pending = true; failed = false; skipped = false;
        frame.hidden = false; recovery.hidden = true; links.value = '';
        show(host.dataset.loading);
        frame.src = origin + '/?parent=' + encodeURIComponent(location.origin);
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!ready) { show(host.dataset.unavailable); recovery.hidden = false; }
        }, 20000);
      };
      window.addEventListener('message', event => {
        if (skipped || event.origin !== origin || event.source !== frame.contentWindow || event.data?.source !== 'joa-photos-v1') return;
        const data = event.data;
        if (data.type === 'ready') { init(); return; }
        if (data.type === 'resize' && Number.isFinite(data.height)) {
          frame.style.height = Math.max(280, Math.min(1200, data.height)) + 'px'; return;
        }
        if (data.type !== 'state' || !Array.isArray(data.photos) || data.photos.length > 5) return;
        if (!data.photos.every(photo => typeof photo.name === 'string' && photo.name.length <= 180 && /^[a-f0-9]{64}$/.test(photo.token))) return;
        ready = data.ready === true; pending = data.pending === true; failed = data.failed === true;
        links.value = data.photos.map((photo, index) => (index + 1) + '. ' + photo.name.replace(/[\r\n]/g, ' ') + '\n' + origin + '/_api/photo?token=' + photo.token).join('\n\n');
        if (ready) { clearTimeout(timer); recovery.hidden = true; }
        show(failed ? host.dataset.failed : pending ? host.dataset.wait : '');
      });
      form.addEventListener('submit', event => {
        if (!skipped && (!ready || pending || failed)) {
          event.preventDefault(); event.stopImmediatePropagation();
          show(failed ? host.dataset.failed : ready ? host.dataset.wait : host.dataset.unavailable);
          if (!ready) recovery.hidden = false;
          status.focus(); host.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      }, true);
      host.querySelector('[data-photo-retry]').addEventListener('click', launch);
      host.querySelector('[data-photo-skip]').addEventListener('click', () => {
        skipped = true; pending = false; links.value = ''; frame.hidden = true;
        frame.src = 'about:blank'; recovery.hidden = true;
        try { sessionStorage.removeItem(key); } catch {}
        show(host.dataset.skipped);
      });
      launch();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), {once: true});
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-necklace-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-necklace-details')) {
    customElements.define('joa-necklace-details', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        import('@shopify/events').then(({ StandardEvents }) => {
          if (signal.aborted) return;
          this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
            if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
            event.promise.then(({ detail }) => {
              if (signal.aborted || !detail?.html || String(detail.productId) !== this.dataset.productId) return;
              const next = detail.html.querySelector('joa-necklace-details');
              if (!next || next.dataset.productId !== this.dataset.productId) return;
              const openKey = this.querySelector('details[open]')?.dataset.detail;
              this.replaceChildren(...Array.from(next.childNodes, node => node.cloneNode(true)));
              this.dataset.variantId = next.dataset.variantId;
              this.querySelectorAll('details').forEach(item => { item.open = item.dataset.detail === openKey; });
            }).catch(error => {
              if (error?.name !== 'AbortError') console.warn('Necklace details could not be updated.', error);
            });
          }, { signal });
        }).catch(error => console.warn('Necklace details could not be initialized.', error));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-order-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-joa-order-tracking]');
    if (!root) return;
    const guide = root.querySelector('[data-joa-tracking-guide]');
    const journey = root.querySelector('[data-joa-tracking-journey]');
    const frame = root.querySelector('#jot-order-frame');
    const update = () => {
      const key = new URLSearchParams(window.location.hash.slice(1)).get('j') || '';
      const hasPrivateLink = /^kj1\.\d{1,24}\.[A-Za-z0-9_-]{16,128}$/.test(key);
      guide.hidden = hasPrivateLink && Boolean(frame);
      journey.hidden = !guide.hidden;
      if (frame && frame.src) {
        const url = new URL(frame.src);
        url.hash = hasPrivateLink ? `j=${encodeURIComponent(key)}` : '';
        if (frame.src !== url.href) frame.src = url.href;
      }
    };
    update();
    window.addEventListener('hashchange', update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-ring-quiz-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  const host = document.querySelector('[data-rq-tools]');
  if (!host || window.JoaRingFinder) return;
  let copy;
  try { copy = JSON.parse(host.querySelector('[data-rq-copy]').textContent); } catch { return; }
  for (const key of Object.keys(copy)) copy[key] = String(copy[key]).replace(/&(amp|quot|lt|gt|#39);/g, (_, entity) => ({ amp: '&', quot: '"', lt: '<', gt: '>', '#39': "'" })[entity]);
  const keys = { saved: 'joa-saved-designs-v1', pending: 'joa-ring-pending-v1', answers: 'joa-ring-answers-v1' };
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,149}$/.test(value);
  const text = (key, values = {}) => Object.entries(values).reduce((value, [k, v]) => value.replaceAll(`{${k}}`, String(v)), copy[key] || key);
  const make = (tag, className, value) => { const n = document.createElement(tag); if (className) n.className = className; if (value != null) n.textContent = value; return n; };
  const read = (key, fallback = []) => { try { const v = JSON.parse(localStorage.getItem(key) || 'null'); return v ?? fallback; } catch { return fallback; } };
  const write = (key, value) => { try { const json = JSON.stringify(value); localStorage.setItem(key, json); return localStorage.getItem(key) === json; } catch { return false; } };
  const readItems = key => { const v = read(key); return Array.isArray(v) ? v.filter(p => validHandle(p?.handle) && typeof p.title === 'string').slice(0, 100) : []; };
  const imageUrl = (value, width = 600) => { if (typeof value !== 'string' || !value.trim()) return ''; try { const u = new URL(value, location.origin); if (u.protocol !== 'https:' || (u.origin !== location.origin && u.hostname !== 'cdn.shopify.com')) return ''; u.searchParams.set('width', width); return u.href; } catch { return ''; } };
  const root = host.dataset.root || '/';
  const productUrl = handle => `${root}products/${encodeURIComponent(handle)}`;
  const money = (cents, currency = host.dataset.currency || 'USD') => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(cents / 100); } catch { return `${cents / 100} ${currency}`; } };
  // Reporting uses a random browser identifier only after analytics consent.
  // Email requests remain a separate, customer-initiated event and never subscribe a list.
  const analyticsKey = 'joa-ring-analytics-v1';
  const visitorKey = 'joa-ring-visitor-v1';
  const quizTest = () => window.Shopify?.designMode === true || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || new URLSearchParams(location.search).get('rq_test') === '1';
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const reportingState = value => { const node=document.querySelector('[data-ring-quiz]'); if(node)node.dataset.reportingState=value; };
  const validId = value => typeof value === 'string' && /^[a-zA-Z0-9:_-]{1,120}$/.test(value);
  let waitingEvents = [], flushing = false, retryTimer = null, memoryVisitorId = '';
  function readQueue() {
    const queue = read(analyticsKey, []);
    return Array.isArray(queue) ? queue.filter(x => validId(x?.attempt_id) && ['started','completed'].includes(x.name) && Number.isFinite(x.at) && Date.now()-x.at < 604800000).slice(-20) : [];
  }
  function visitorId() {
    const current = read(visitorKey, '');
    if (validId(current) && current.startsWith('rq:')) return current;
    const id = memoryVisitorId || (memoryVisitorId = `rq:${crypto.randomUUID()}`);
    write(visitorKey, id);
    return id;
  }
  async function sendQuizEvent(payload) {
    const quizRoot=document.querySelector('[data-ring-quiz]');
    if(!quizRoot || !/^[A-Za-z0-9]{6}$/.test(quizRoot.dataset.emailSite || '')) throw Error('Email delivery unavailable');
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
    try {
      const response=await fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(quizRoot.dataset.emailSite)}`,{
        method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-07-15'},
        body:JSON.stringify(payload),credentials:'omit',signal:controller.signal
      });
      if(response.status!==202) throw Error('Email request rejected');
    } finally { clearTimeout(timer); }
  }
  async function flushQuizEvents() {
    if (flushing || !analyticsAllowed()) return;
    const quizRoot = document.querySelector('[data-ring-quiz]');
    if (!quizRoot || !/^[A-Za-z0-9]{6}$/.test(quizRoot.dataset.emailSite || '')) return;
    flushing = true;
    let failed = false;
    try {
      const externalId = visitorId();
      while (readQueue().length) {
        const item = readQueue()[0];
        if (!analyticsAllowed()) break;
        const metricName = `Ring Quiz ${item.name === 'completed' ? 'Completed' : 'Started'}${item.is_test ? ' - Test' : ''}`;
        const payload = {data:{type:'event',attributes:{unique_id:`${item.attempt_id}:${item.name}`,time:new Date(item.at).toISOString(),properties:{quiz_version:3,source:'ring_quiz',attempt_id:item.attempt_id,is_test:item.is_test,result_count:item.result_count,product_handles:item.product_handles},metric:{data:{type:'metric',attributes:{name:metricName}}},profile:{data:{type:'profile',attributes:{external_id:externalId}}}}}};
        try {
          await sendQuizEvent(payload);
          reportingState('accepted');
          if (!write(analyticsKey, readQueue().filter(x => x.attempt_id !== item.attempt_id || x.name !== item.name))) break;
        } catch { reportingState('retry_pending'); failed = true; break; }
      }
    } finally {
      flushing = false;
      if (failed && !retryTimer) retryTimer = setTimeout(() => { retryTimer = null; flushQuizEvents(); }, 30000);
    }
  }
  function reportQuiz(name, data) {
    initializeQuizPrivacy();
    if (!['started','completed'].includes(name) || !validId(data.attempt_id)) return;
    const item = {name,attempt_id:data.attempt_id,at:Date.now(),is_test:!!quizTest(),result_count:Array.isArray(data.product_handles)?data.product_handles.length:0,product_handles:Array.isArray(data.product_handles)?data.product_handles.filter(validHandle).slice(0,3):[]};
    if (!analyticsAllowed()) { reportingState('awaiting_analytics_consent'); waitingEvents = [...waitingEvents.filter(x => x.attempt_id !== item.attempt_id || x.name !== name),item].slice(-20); return; }
    const queue=readQueue();
    if (!queue.some(x=>x.attempt_id===item.attempt_id&&x.name===name)) write(analyticsKey,[...queue,item].slice(-20));
    flushQuizEvents();
  }
  function syncQuizConsent() {
    if (!analyticsAllowed()) { try { localStorage.removeItem(analyticsKey); localStorage.removeItem(visitorKey); } catch {} return; }
    const pending=waitingEvents; waitingEvents=[];
    pending.forEach(item=>reportQuiz(item.name,item));
    flushQuizEvents();
  }
  document.addEventListener('visitorConsentCollected',syncQuizConsent);
  window.addEventListener('online',syncQuizConsent);
  window.addEventListener('pageshow',syncQuizConsent);
  let privacyAttempts=0, privacyLoading=false;
  function initializeQuizPrivacy() {
    if (!document.querySelector('[data-ring-quiz]')) return;
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') { syncQuizConsent(); return; }
    if (!privacyLoading && typeof window.Shopify?.loadFeatures === 'function') { privacyLoading=true;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],syncQuizConsent); }
    privacyAttempts++;
    if (privacyAttempts < 20) setTimeout(initializeQuizPrivacy,500);
  }
  initializeQuizPrivacy();
  const track = (name, data = {}) => {
    document.dispatchEvent(new CustomEvent('joa:ring-quiz', { detail: { name, ...data } }));
    reportQuiz(name, data);
    if (analyticsAllowed()) {
      try { window.Shopify?.analytics?.publish?.(`ring_quiz_${name}`, { quiz_version: 3, ...data }); } catch {}
    }
  };
  const safeItem = p => ({ handle: p.handle, title: p.title, image: imageUrl(p.image), price: p.displayPrice || p.price, currency: p.currency, kind: 'Engagement ring', family: p.family || '', shape: p.shape || '', available: p.available });
  function addPending(products) {
    const old = readItems(keys.pending), next = [...old];
    for (const p of products) if (validHandle(p.handle) && !next.some(x => x.handle === p.handle)) next.push(safeItem(p));
    if (next.length > 12) return { ok: false, error: text('pending_limit') };
    if (!write(keys.pending, next)) return { ok: false, error: text('storage_error') };
    document.dispatchEvent(new Event('joa:pending-refresh'));
    track('add_later', { product_handles: products.map(p => p.handle) });
    return { ok: true };
  }
  function saveAll(products) {
    const old = readItems(keys.saved), next = [...old];
    for (const p of products) if (validHandle(p.handle) && !next.some(x => x.handle === p.handle)) next.push(safeItem(p));
    if (next.length > 100) return { ok: false, error: text('save_limit') };
    if (!write(keys.saved, next)) return { ok: false, error: text('storage_error') };
    document.dispatchEvent(new Event('joa:saved-refresh'));
    track('saved', { product_handles: products.map(p => p.handle) });
    return { ok: true };
  }
  async function requestProduct(handle) {
    const ctrl = new AbortController(), timer = setTimeout(() => ctrl.abort(), 12000);
    try {
      const r = await fetch(`${productUrl(handle)}.js`, { signal: ctrl.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('Unavailable');
      const p = await r.json();
      if (p.handle !== handle || !Number.isFinite(p.price_min)) throw new Error('Invalid product');
      return p;
    } finally { clearTimeout(timer); }
  }
  function shareLink(products, answers = {}) {
    const u = new URL(`${root}pages/find-your-ring`, location.origin);
    const hashes = new URLSearchParams(); hashes.set('rings', products.map(p => p.handle).filter(validHandle).slice(0, 3).join(','));
    const safe = {};
    for (const k of ['style', 'shape', 'band', 'presence', 'detail', 'metal', 'priority']) {
      const v = answers[k]; if (typeof v === 'string' && v !== 'any' && /^[a-z_]{1,30}$/.test(v)) safe[k] = v;
      if (k === 'shape' && Array.isArray(v) && v.length) safe[k] = v.filter(x => /^[a-z]{1,12}$/.test(x)).slice(0, 3);
    }
    if (Object.keys(safe).length) hashes.set('q', JSON.stringify(safe));
    u.hash = hashes.toString();
    return u.href;
  }
  function rank(catalog, traits, a = {}) {
    const shapes = Array.isArray(a.shape) ? a.shape : [];
    const pWeight = { shape: a.priority === 'shape' ? 120 : 80, band: a.priority === 'band' ? 110 : 65, style: a.priority === 'style' ? 95 : 34 };
    return catalog.filter(p => {
      const t=traits[p.handle];
      if(!t || t.schema_version!==2 || t.eligible!==true || t.confirmed?.shape!==true || t.confirmed?.band!==true || !Array.isArray(t.styles) || !t.features || !p.available || !Number.isFinite(p.price) || p.price<=0)return false;
      if(shapes.length && (t.confirmed?.shape!==true || !shapes.includes(t.shape)))return false;
      if(a.band && a.band!=='any' && (t.confirmed?.band!==true || a.band!==t.band))return false;
      if(a.detail && a.detail!=='any' && t.features?.[a.detail]!==true)return false;
      if(Number.isFinite(a.budgetMax) && a.budgetCurrency===p.currency && p.price>a.budgetMax)return false;
      return true;
    }).map((p, index) => {
      const t = traits[p.handle], reasons = [], warnings = []; let score = 0;
      if (a.detail && t.features[a.detail]===true) { score += 24; reasons.push([`reason_${a.detail}`]); }
      if (shapes.length) { score += pWeight.shape; reasons.push(['reason_shape', { shape: text(`shape_${t.shape}`).toLowerCase() }]); }
      if (a.band && a.band !== 'any') {
        score += pWeight.band; reasons.push([`reason_band_${t.band}`]);
      }
      if (a.style && t.styles.includes(a.style)) { score += pWeight.style; reasons.push([`reason_${a.style}`]); }
      if (a.presence && t.presence === a.presence) { score += 20; reasons.push([`reason_${a.presence}`]); }
      if (!reasons.length) reasons.push([`reason_band_${t.band}`], [`reason_${t.styles[0]}`]);
      return { ...p, ...t, index, score, reasons: reasons.slice(0, 3), warnings, overBudget:false };
    }).sort((x, y) => (a.priority==='budget'?x.price-y.price:0) || y.score-x.score || x.index-y.index);
  }
  function emailEvent(products, answers, preferences, email, uniqueId) {
    const picks=products.filter(p=>validHandle(p.handle)).slice(0,3).map(p=>({handle:p.handle,title:p.title,url:new URL(productUrl(p.handle),location.origin).href,image_url:imageUrl(p.image,640),price_label:`${text('from')} ${p.displayPrice}`,currency:p.currency,reasons:(p.reasons||[]).map(([key,values])=>text(key,values))}));
    if(!picks.length||typeof email!=='string'||!email.includes('@')||!uniqueId)throw Error('Invalid results request');
    return {data:{type:'event',attributes:{unique_id:uniqueId,properties:{quiz_version:3,source:'ring_quiz',setup_test:!!quizTest(),primary:picks[0],alternatives:picks.slice(1),alternative_count:picks.length-1,preferences,results_url:shareLink(products,answers)},metric:{data:{type:'metric',attributes:{name:'Ring Quiz Results Requested'}}},profile:{data:{type:'profile',attributes:{email}}}}}};
  }
  window.JoaRingFinder = { text, copy, make, read, write, readItems, keys, root, validHandle, productUrl, imageUrl, money, addPending, saveAll, shareLink, rank, emailEvent, sendQuizEvent, track, requestProduct, host };
  document.dispatchEvent(new Event('joa:ring-finder-ready'));
  document.addEventListener('joa:cart-add-confirmed', e => {
    const handle = e.detail?.handle;
    if (!validHandle(handle)) return;
    const old = readItems(keys.pending);
    if (!old.some(p => p.handle === handle)) return;
    const ok = write(keys.pending, old.filter(p => p.handle !== handle));
    if (ok) document.dispatchEvent(new Event('joa:pending-refresh'));
    const message = document.querySelector('[data-rq-pending-status]');
    if (message) message.textContent = text(ok ? 'pending_complete' : 'pending_storage_error');
  });
  const pending = document.querySelector('[data-rq-pending]');
  if (!pending) return;
  let generation = 0;
  const status = pending.querySelector('[data-rq-pending-status]');
  function remove(handle, message) {
    const next = readItems(keys.pending).filter(p => p.handle !== handle);
    if (!write(keys.pending, next)) { status.textContent = text('pending_storage_error'); return; }
    render(); status.textContent = message;
  }
  function render() {
    const gen = ++generation, items = readItems(keys.pending), list = pending.querySelector('[data-rq-pending-list]');
    pending.hidden = !items.length; document.body.classList.toggle('has-quiz-pending', !!items.length); list.replaceChildren();
    const currency = host.dataset.currency || 'USD';
    items.forEach(item => {
      const row = make('article', 'rq-pending-row'), picture = make('a', 'rq-pending-image'); picture.href = productUrl(item.handle);
      const src = imageUrl(item.image, 320); if (src) { const img = make('img'); img.src = src; img.alt = item.title; img.width = 160; img.height = 160; img.loading = 'lazy'; picture.append(img); }
      const info = make('div', 'rq-pending-info'), title = make('h3'), link = make('a', '', item.title); link.href = productUrl(item.handle); title.append(link);
      const warning = make('p', 'rq-pending-warning', text('pending_warning'));
      const price = make('p', 'rq-fine', item.currency === currency ? `${text('from')} ${item.price}` : text('pending_price_error'));
      info.append(title, warning, price);
      const actions = make('div', 'rq-pending-actions'), configure = make('a', 'rq-button rq-button-small', text('pending_configure'));
      configure.href = productUrl(item.handle); configure.dataset.quickRing = item.handle; configure.setAttribute('aria-haspopup', 'dialog');
      configure.setAttribute('aria-label', `${configure.textContent} — ${item.title}`);
      const removeButton = make('button', 'rq-text-button', text('pending_remove')); removeButton.type = 'button'; removeButton.setAttribute('aria-label', `${text('pending_remove')} ${item.title}`);
      removeButton.addEventListener('click', () => { remove(item.handle, text('pending_removed')); pending.querySelector('a,button')?.focus(); });
      actions.append(configure, removeButton); row.append(picture, info, actions); list.append(row);
      requestProduct(item.handle).then(p => {
        if (gen !== generation) return;
        price.textContent = `${text('from')} ${money(p.price_min, currency)} ${currency}`;
        if (!p.available) { configure.removeAttribute('data-quick-ring'); configure.classList.remove('rq-button'); configure.textContent = text('view'); warning.textContent = text('pending_unavailable'); }
      }).catch(() => { if (gen === generation) { price.textContent = text('pending_price_error'); configure.removeAttribute('data-quick-ring'); configure.textContent = text('view'); configure.href = productUrl(item.handle); } });
    });
  }
  document.addEventListener('joa:pending-refresh', render);
  window.addEventListener('pageshow', render);
  window.addEventListener('storage', e => { if (e.key === null || e.key === keys.pending) render(); });
  render();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-ring-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-ring-specifications')) {
    customElements.define('joa-ring-specifications', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.scope = this.closest('.product-information');
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateTotal());
        };
        const onOptions = event => {
          if (!(event.target instanceof Element) || !this.scope?.contains(event.target) || event.target.closest('.mw-tingle,.joa-quick-ring')) return;
          this.refresh();
        };
        document.addEventListener('joa:options-designed', onOptions, { signal });
        this.scope?.addEventListener('change', onOptions, { signal });
        window.addEventListener('pageshow', this.refresh, { signal });
        this.refresh();
      }
      updateTotal() {
        if (!this.isConnected || this.dataset.settingMin === '' || this.dataset.settingMax === '') return;
        const input = this.scope?.querySelector('.mw-apo-container .joa-option--diamond-size input.mw-option__control[type="radio"]:checked');
        const label = input?.getAttribute('aria-label') || input?.closest('[data-joa-label]')?.dataset.joaLabel || '';
        const match = label.match(/^\s*(\d+(?:\.\d+)?)\s*(?:ct|carat)s?\b/i);
        const centre = match ? Number(match[1]) : NaN;
        const minimum = Number(this.dataset.settingMin), maximum = Number(this.dataset.settingMax);
        let value = this.dataset.selectSize;
        if (Number.isFinite(centre) && centre > 0 && Number.isFinite(minimum) && Number.isFinite(maximum)) {
          const format = weight => String(Math.round(weight * 100) / 100);
          value = `${format(centre + minimum)}${maximum === minimum ? '' : `–${format(centre + maximum)}`} ${this.dataset.caratUnit}`;
        }
        const total = this.querySelector('[data-joa-ring-total]');
        if (total && total.textContent !== value) total.textContent = value;
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joa-trust-ticker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joa-trust-ticker')) {
    customElements.define('joa-trust-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.visibility?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const viewport = this.querySelector('[data-ticker-viewport]');
        const track = this.querySelector('.joa-trust-ticker__track');
        const group = this.querySelector('[data-ticker-group]');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let width = 0;
        let position = 0;
        let boost = 0;
        let lastFrame = 0;
        let visible = true;
        let pointer = null;
        let paused = false;
        let focused = false;
        const toggle = this.querySelector('[data-ticker-pause]');
        const paint = () => {
          if (!width) return;
          position = ((position % width) + width) % width;
          track.style.transform = 'translate3d(' + -position + 'px,0,0)';
        };
        const animate = (now) => {
          if (!this.isConnected || reduced.matches || document.hidden || !visible || paused || focused) {
            this.frame = 0;
            lastFrame = 0;
            return;
          }
          const elapsed = lastFrame ? Math.min((now - lastFrame) / 1000, .05) : 0;
          lastFrame = now;
          position += (30 + boost) * elapsed;
          boost *= Math.exp(-3 * elapsed);
          if (boost < .1) boost = 0;
          paint();
          this.frame = requestAnimationFrame(animate);
        };
        const start = () => {
          if (!this.frame && !reduced.matches && !document.hidden && visible && !paused && !focused) this.frame = requestAnimationFrame(animate);
        };
        const release = () => {
          if (pointer && viewport.hasPointerCapture(pointer.id)) viewport.releasePointerCapture(pointer.id);
          pointer = null;
          this.removeAttribute('data-dragging');
        };
        const sync = () => {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          lastFrame = 0;
          boost = 0;
          release();
          this.toggleAttribute('data-animated', !reduced.matches);
          if (toggle) toggle.hidden = reduced.matches;
          if (reduced.matches) {
            track.style.removeProperty('transform');
            viewport.setAttribute('tabindex','0');
          } else {
            viewport.setAttribute('tabindex','0');
            viewport.scrollLeft = 0;
            width = group.getBoundingClientRect().width;
            paint();
            start();
          }
        };
        toggle?.addEventListener('click', () => {
          paused = !paused;
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          toggle.querySelector('[data-ticker-pause-icon]').toggleAttribute('hidden', paused);
          toggle.querySelector('[data-ticker-play-icon]').toggleAttribute('hidden', !paused);
          if (!paused) start();
        }, options);
        viewport.addEventListener('focus', () => { focused = true; }, options);
        viewport.addEventListener('blur', () => { focused = false; start(); }, options);
        viewport.addEventListener('keydown', (event) => {
          if (reduced.matches || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); position += event.key === 'ArrowRight' ? 160 : -160; paint();
        }, options);
        viewport.addEventListener('pointerdown', (event) => {
          if (reduced.matches || !event.isPrimary || event.button !== 0) return;
          pointer = { id:event.pointerId, x:event.clientX, y:event.clientY, lastX:event.clientX, time:event.timeStamp, horizontal:false };
        }, options);
        viewport.addEventListener('pointermove', (event) => {
          if (!pointer || pointer.id !== event.pointerId) return;
          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;
          if (!pointer.horizontal) {
            if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { release(); return; }
            if (Math.abs(dx) < 8) return;
            pointer.horizontal = true;
            viewport.setPointerCapture(event.pointerId);
            this.setAttribute('data-dragging','');
          }
          const delta = event.clientX - pointer.lastX;
          const elapsed = Math.max(event.timeStamp - pointer.time, 8);
          position -= delta;
          boost = Math.min(900, Math.max(boost, Math.abs(delta) / elapsed * 1000 * .65));
          pointer.lastX = event.clientX;
          pointer.time = event.timeStamp;
          paint();
          event.preventDefault();
        }, options);
        viewport.addEventListener('pointerup', release, options);
        viewport.addEventListener('pointercancel', release, options);
        viewport.addEventListener('lostpointercapture', release, options);
        viewport.addEventListener('pointerleave', () => { if (pointer && !pointer.horizontal) release(); }, options);
        viewport.addEventListener('wheel', (event) => {
          if (reduced.matches || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          const delta = event.deltaX * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientWidth : 1);
          position += delta;
          boost = Math.min(900, boost + Math.abs(delta) * 5);
          paint();
          event.preventDefault();
        }, { ...options, passive:false });
        reduced.addEventListener('change', sync, options);
        document.addEventListener('visibilitychange', start, options);
        this.observer = new ResizeObserver(() => {
          width = group.getBoundingClientRect().width;
          if (!reduced.matches) paint();
        });
        this.observer.observe(group);
        this.visibility = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible) start();
        });
        this.visibility.observe(this);
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.visibility?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
